<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-05-14 14:18:44
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="visible"
      width="30%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        size="small"
        label-width="120px"
      >
        <el-form-item label="密码" prop="passWord1">
          <el-input
            type="password"
            v-model.trim="form.passWord1"
            maxlength="20"
            placeholder="请输入密码"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="再次确认密码" prop="passWord">
          <el-input
            type="password"
            v-model.trim="form.passWord"
            maxlength="20"
            placeholder="请再次输入密码"
            style="width: 90%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" type="primary" @click="handleOk"
          >保 存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from '@/api/manage';
// import { listMixin } from '@/mixins/listMixin';
import { emailResetPassword } from '@/api/system';

export default {
  components: {},
  // mixins: [listMixin],
  props: {},
  data() {
    return {
      disableMixinCreated: true,
      title: '操作',
      visible: false,
      confirmLoading: false,
      form: {},
      validatorRules: {
        name: [
          {
            required: true,
            message: '请输入角色名称',
            trigger: 'blur',
          },
          {
            min: 1,
            max: 100,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur',
          },
        ],
      },
      url: {
        add: 'role/addRole',
        edit: 'role/updteRole',
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.visible = true;
      this.form = { ...record };
      // 查询角色详情
    },
    close() {
      this.$refs.form.resetFields();
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.passWord1 !== this.form.passWord) {
            this.$message.success('两次密码输入不一致!');
            return false;
          }
          const parms = {
            userId: this.form.id,
            password: this.form.passWord,
          };
          emailResetPassword(parms).then((res) => {
            this.$message.success('重置成功!');
            this.visible = false;
            this.$refs.form.resetFields();
          });
        } else {
          return false;
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  .menuBar {
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    /*height: calc(100% - 100px);*/
    height: 300px;
    overflow-y: auto;
  }
}
</style>
